import StockoutRequestorSearch from "./stockoutRequestorSearch.container"

export default StockoutRequestorSearch;